import { useCountries } from 'api/requests/country';

export const useEditDialogWithdrawalAccount = () => {
  const { countries, loading: countriesLoading } = useCountries();

  return {
    countries: countries ?? [],
    countriesLoading,
  };
};
